import * as React from "react";

import { Stack } from "@mui/material";

import RemoteHeadsetVideo from "../../../components/meeting/video/tiles/remote-headset-video/remote-headset-video";
import { WebLayout } from "../../../components/meeting/layouts";
import { useHeadsetConnected } from "../../../hooks/use-headset-connected";
import {
  MeetingToolbar,
  QRCodeToggleButton,
} from "../../../components/meeting/meeting-toolbar";

const RemoteLayout: React.FC = () => {
  const viewHeight = 92;
  const viewWidth = 100;

  // State to control the visibility of the QR code panel
  const [isQRCodeOpen, setIsQRCodeOpen] = React.useState(true);

  /**
   * Toggles the visibility of the QR code drawer panel
   */
  const toggleQRCode = () => {
    setIsQRCodeOpen(!isQRCodeOpen);
  };

  useHeadsetConnected(() => setIsQRCodeOpen(false));

  const stopEvents = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      <Stack
        width={"100vw"}
        height={"100vh"}
        onClick={stopEvents}
        onMouseDown={stopEvents}
        onMouseUp={stopEvents}
        onContextMenu={stopEvents}
        sx={{
          display: "flex",
          backgroundColor: "black",
        }}
      >
        <MeetingToolbar>
          <QRCodeToggleButton
            isOpen={isQRCodeOpen}
            onToggle={toggleQRCode}
          />
        </MeetingToolbar>
        <WebLayout
          viewHeight={viewHeight}
          viewWidth={viewWidth}
          layout="remote"
        />
        <RemoteHeadsetVideo />
      </Stack>
    </>
  );
};

export default RemoteLayout;
